


























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class LoadingCommonTopic extends Vue {
  created() {}
}
